import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ReturnServices from '@root/modules/Sellers/Return/services/return';
import ReturnDetailOrder from '../../Return/pages/return-not-access/ReturnDetailOrder';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { Card, Col, Form, Input, Row } from 'antd';
import MypageServices from '@root/modules/Sellers/Mypage/services/mypage';

const ShippingReturnTrackingDetail = () => {
  const listBreadcrumb = [
    {
      tittle: '배송관리',
      url: ''
    },
    {
      tittle: '반환 조회',
      url: '/admin/seller/shipping/return-tracking'
    },
    {
      tittle: '반환 상세',
      url: ''
    }
  ];

  const { productId }: any = useParams();
  const [productComment, setProductComment] = useState([] as any);
  const [productOrder, setProductOrder] = useState([] as any);
  const [recipient, setRecipient] = useState({});
  const [form] = Form.useForm<any>();

  const getDetailReturn = async () => {
    const returnDetail = await ReturnServices.getDetailReturn(productId);
    setRecipient(returnDetail.data);
    setProductComment(returnDetail.data.order);
    const products = returnDetail.data?.orderProducts.products || [];

    setProductOrder(products);
  };

  const getInfoAccount = async () => {
    const { data } = await MypageServices.getSellerID();
    form.setFieldsValue({
      recipientName: data.lastName + ' ' + data.firstName,
      recipientPhone: data.phoneNumber,
      shippingAddress: data.detailAddress,
      detailReturnAddress: data.detailAddress,
      detailReturnAddress2: data.detailAddress2,
      postalCode: data.postalCode,
      country: data.country,
      state: data.state,
      city: data.city
    });
  };

  useEffect(() => {
    getDetailReturn();
    getInfoAccount();
  }, []);

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <ReturnDetailOrder
            recipient={recipient}
            productComment={productComment}
            productOrder={productOrder}
            refetch={getDetailReturn}
            screenName="ReturnTrackingDetail"
            hiddenModifyDelete={true}
          />

          <div
            className="recipient-wrapper"
            style={{ padding: '20px', background: 'white', paddingTop: 0 }}
          >
            <Form
              form={form}
              layout="vertical"
              className="recipient"
              style={{ padding: '19px 0px', marginBottom: '10px' }}
              initialValues={{
                recipientName: 1,
                recipientPhone: 'recipientPhone',
                shippingAddress: 'shippingAddress',
                detailReturnAddress: 'detailReturnAddress',
                postalCode: 'postalCode',
                country: 'country'
              }}
            >
              <Row>
                <Col span={5} style={{ paddingRight: '10px' }}>
                  <Form.Item
                    label="Recipient Name"
                    name="recipientName"
                    className="recipient-name"
                  >
                    <Input className="border-input" disabled />
                  </Form.Item>
                </Col>
                <Col span={5} style={{ paddingRight: '10px' }}>
                  <Form.Item
                    label="Recipient Phone Number"
                    name="recipientPhone"
                    className="recipient-name"
                  >
                    <Input className="border-input" disabled />
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <div role="cell" className="ant-col ant-form-item-label">
                    <label title="Shipping Country/Address">
                      Shipping Country/Address
                    </label>
                  </div>
                  <Row>
                    <Col span={5} style={{ paddingRight: '10px' }}>
                      <Form.Item name="country" className="recipient-name">
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                    <Col span={19}>
                      <Form.Item
                        name="shippingAddress"
                        className="recipient-name"
                      >
                        <Input className="border-input" disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={10}>
                  <div></div>
                </Col>
                <Col span={14}>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={12} style={{ paddingRight: '10px' }}>
                      <Form.Item
                        name="detailReturnAddress2"
                        className="recipient-name"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="detailReturnAddress"
                        className="recipient-name"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px' }}>
                    <Col span={8} style={{ paddingRight: '10px' }}>
                      <Form.Item name="city" className="recipient-name">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={8} style={{ paddingRight: '10px' }}>
                      <Form.Item name="state" className="recipient-name">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="postalCode" className="recipient-name">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </Card>
      </div>
    </>
  );
};
export default ShippingReturnTrackingDetail;
